import React from 'react';
import classes from "../vpn.module.css";
import AddBalance from "../addBalance/addBalance";
import {useTelegram} from "../../../../hooks/useTelegram";

const Header = ({client, getClient, openAddBalance, setOpenAddBalance}) => {
    const {user} = useTelegram()
    const isVip = String(client?.tariff_name || '').toUpperCase() === 'VIP'
    const tariffName = client?.tariff_name || '—'
    const tariffDay = Number.isFinite(Number(client?.tariff_price_per_day))
        ? Number(client?.tariff_price_per_day)
        : null
    const tariffMonth = Number.isFinite(Number(client?.tariff_price_per_month))
        ? Number(client?.tariff_price_per_month)
        : null
    const tariffPriceText =
        tariffDay !== null && tariffMonth !== null
            ? `${tariffDay}₽/сут, ${tariffMonth}₽/мес`
            : ''

    return (
        <div className={classes.header}>
            <div className={classes.headerText}>
                <div className={classes.username}>
                    <div className={classes.photoBlock}>
                        <img alt={''} src={user?.photo_url} className={classes.photo}/>
                    </div>
                    <div>
                        <div>{user?.first_name} {user?.last_name}</div>
                        <div style={{fontSize:'16px'}}>id{client?.telegram_id}</div>
                    </div>
                </div>
            </div>
            <div className={classes.balance}>
                <div className={classes.tariff_text}>
                    Тариф: {tariffPriceText ? `${tariffPriceText}` : '-'}
                </div>
                <div className={classes.balance_text}>Баланс: {isVip ? '∞ ' : client?.balance}₽</div>
                {(!isVip || client.telegram_id==='480642114') && <div className={classes.addBalance} onClick={()=>setOpenAddBalance(true)}>Пополнить</div>}
            </div>
            {false && <div className={classes.headerButton}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="19.5" stroke="#FFF"/>
                    <path transform="translate(-1,0)" d="M19.5034 23.9063V23.8031C19.5147 22.7075 19.6281 21.8356 19.8435 21.1874C20.059 20.5392 20.3651 20.0143 20.7619 19.6128C21.1587 19.2113 21.6349 18.8413 22.1905 18.5029C22.5249 18.2964 22.8254 18.0526 23.0918 17.7715C23.3583 17.4847 23.568 17.1549 23.7211 16.782C23.8798 16.4092 23.9592 15.9962 23.9592 15.543C23.9592 14.9809 23.8288 14.4933 23.568 14.0803C23.3073 13.6673 22.9586 13.3489 22.5221 13.1252C22.0856 12.9015 21.6009 12.7897 21.068 12.7897C20.6032 12.7897 20.1553 12.8872 19.7245 13.0822C19.2937 13.2772 18.9337 13.5841 18.6446 14.0029C18.3554 14.4216 18.1882 14.9694 18.1429 15.6463H16C16.0454 14.6711 16.2948 13.8365 16.7483 13.1424C17.2075 12.4484 17.8112 11.9178 18.5595 11.5507C19.3135 11.1836 20.1497 11 21.068 11C22.0658 11 22.9331 11.2008 23.6701 11.6023C24.4127 12.0038 24.9853 12.5545 25.3878 13.2543C25.7959 13.9541 26 14.7514 26 15.6463C26 16.2772 25.9036 16.848 25.7109 17.3585C25.5238 17.869 25.2517 18.325 24.8946 18.7266C24.5431 19.1281 24.1179 19.4837 23.619 19.7935C23.1202 20.109 22.7205 20.4417 22.4201 20.7916C22.1196 21.1358 21.9014 21.5459 21.7653 22.022C21.6293 22.4981 21.5556 23.0918 21.5442 23.8031V23.9063H19.5034ZM20.5918 29C20.1723 29 19.8124 28.848 19.5119 28.544C19.2115 28.24 19.0612 27.8757 19.0612 27.4512C19.0612 27.0268 19.2115 26.6625 19.5119 26.3585C19.8124 26.0545 20.1723 25.9025 20.5918 25.9025C21.0113 25.9025 21.3713 26.0545 21.6718 26.3585C21.9722 26.6625 22.1224 27.0268 22.1224 27.4512C22.1224 27.7323 22.0516 27.9904 21.9099 28.2256C21.7738 28.4608 21.5896 28.6501 21.3571 28.7935C21.1304 28.9312 20.8753 29 20.5918 29Z" fill="white"/>
                </svg>
            </div>}
            <AddBalance isOpen={openAddBalance} setIsOpen={setOpenAddBalance} client={client} getClient={getClient}/>
        </div>
    );
};

export default Header;